import * as React from 'react';
import {
  CheckOut40,
  Class40,
  Corpus40,
  Floor40,
  HeightCeiling40,
  Parking40,
  Repair40,
  TypeBuild40,
} from '@cian/ui-kit/icons';
import { EItemType } from '../types/newbuilding/specification';

export const SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EItemType.FinishDate]: <CheckOut40 />,
  [EItemType.NewbuildingClass]: <Class40 />,
  [EItemType.Floors]: <Floor40 />,
  [EItemType.Houses]: <Corpus40 />,
  [EItemType.MaterialType]: <TypeBuild40 />,
  [EItemType.CeilingHeight]: <HeightCeiling40 />,
  [EItemType.Decorations]: <Repair40 />,
  [EItemType.Parking]: <Parking40 />,
};
